import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

const ButtonLink = styled(Link)`
  display: inline-block;
  width: 16.3rem;
  margin: 1.8rem;
  padding: 1.3rem 0;
  color: #f7f7f5;
  background-color: #3b4e57;
  font-family: mr-eaves-modern;
  font-size: 1.1rem;
  letter-spacing: 0.2rem;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`

export default ButtonLink
